import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  toastDialog: {
    minHeight: 340,
    width: 500,
    maxHeight: 420,
  },
  successText: {
    color: 'rgb(0, 213, 146)',
  },
}));
